export default "__VITE_ASSET__BA65SEtp__";